// extracted by mini-css-extract-plugin
export default {"heart-large":"Post_heart-large__2Asal","grow-shrink":"Post_grow-shrink__26IS0","image-container":"Post_image-container__0rpJW"};